export default "__VITE_ASSET__BWQ3hKhp__"